export default __webpack_public_path__ + "static/media/US.0203e856.svg";